import { render, staticRenderFns } from "./subDir.vue?vue&type=template&id=4d48143c"
import script from "./subDir.vue?vue&type=script&lang=js"
export * from "./subDir.vue?vue&type=script&lang=js"
import style0 from "./subDir.vue?vue&type=style&index=0&id=4d48143c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports